import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { MeResponse } from '@central/types';

interface AuthState {
  accessToken: string | null;
  user: MeResponse | null;
  setAuth: (accessToken: string, user: MeResponse) => void;
  setAccessToken: (accessToken: string) => void;
  setUser: (user: MeResponse) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      setAuth: (accessToken, user) => set({ accessToken, user }),
      setAccessToken: (accessToken) => set({ accessToken }),
      setUser: (user) => set({ user }),
      clearAuth: () => set({ accessToken: null, user: null }),
    }),
    {
      name: 'central-auth',
      partialize: (state) => ({ user: state.user }),
    },
  ),
);
